import React, { Component } from "react";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import Image from '../global/Image';
import { Link } from 'react-router-dom';

export default class NewsArticles extends Component {
	  	
	render () {
		
		let articles = this.props.articles;
										
	    return (
	
		    <div className="c-page__block c-page__block--inset-mobile c-page__block--load-effect">
				
				<div className="l-grid">
		    
		    		<div className="l-grid__col">
		    		
		    			<div className="c-news">
		    			
		    				<ResponsiveMasonry columnsCountBreakPoints={{480: 1, 760: 2, 960: 3, 1650: 4}}>
								
								<Masonry>
		    			
									{articles.map((article,i) =>
										{
											if (article.url.indexOf('https') === -1) {
												
												return (
													
													<div className="c-news__article" key={i}>
													
														<Link to={{ pathname: article.url }} className="c-news__article__inner">
															
															<div className="c-news__article__image">
																
																<Image width={article.width} height={article.height} srcset={article.srcset} src={article.src} />
															
															</div>
															
															<h6 className="c-news__article__date" dangerouslySetInnerHTML={ {__html:article.date}}></h6>
															
															<h3 className="c-news__article__heading" dangerouslySetInnerHTML={ {__html:article.title}}></h3>
															
															<div className="scope-text scope-text--small scope-text--faded" dangerouslySetInnerHTML={ {__html:article.excerpt}}></div>
															
															<p className="c-news__article__more" dangerouslySetInnerHTML={ {__html:'Read More<svg width="6" height="10" viewBox="0 0 6 10"><path d="M0.582031 4.58203V-5.94956e-08L5.16406 4.58203L0.582031 9.16406V4.58203Z"/></svg>'}}></p>
															
														</Link>
														
													</div>
													
												)
												
											} else {
												
												return (
													
													<div className="c-news__article" key={i}>
													
														<a href={article.url} className="c-news__article__inner" target="_blank">
															
															<div className="c-news__article__image">
																
																<Image width={article.width} height={article.height} srcset={article.srcset} src={article.src} />
															
															</div>
															
															<h6 className="c-news__article__date" dangerouslySetInnerHTML={ {__html:article.date}}></h6>
															
															<h3 className="c-news__article__heading" dangerouslySetInnerHTML={ {__html:article.title}}></h3>
															
															<div className="scope-text scope-text--small scope-text--faded" dangerouslySetInnerHTML={ {__html:article.excerpt}}></div>
															
															<p className="c-news__article__more" dangerouslySetInnerHTML={ {__html:'Read More<svg width="6" height="10" viewBox="0 0 6 10"><path d="M0.582031 4.58203V-5.94956e-08L5.16406 4.58203L0.582031 9.16406V4.58203Z"/></svg>'}}></p>
															
														</a>
														
													</div>
													
												)
												
											}
										}				
									)}
									
								</Masonry>
								
							</ResponsiveMasonry>
							
						</div>
				    
				    </div>
				    
				</div>
		    
		    </div>
		)
	}
}
